export default __webpack_public_path__ + "img/tremors/tremors3_700.webp";